import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
export const RichTextBlock = JSX((props) => {
    const { __html, richVersion = '', ...rest } = props;
    return (_jsx(BlockWrapper, { defaultPadding: "p-0", ...rest, children: _jsx(RichText, { __html: __html, richVersion: richVersion }) }));
});
//# sourceMappingURL=RichTextBlock.js.map